import React from 'react';
import { Modal } from 'antd';
import { Button } from '@lingxi-common-component/sirius-ui';
import { getIn18Text } from 'api';
import { ShieldSvgIcon } from '@web-common/utils/safeBrowsing';
import styles from './index.module.scss';
const SafeBrowsingModal = ({ visible, targetUrl, remainCnt, riskLevel, free, loading, onCancel, onNormalOpen, onSafeOpen }) => {
    const isHighRisk = !loading && typeof riskLevel === 'number' && riskLevel >= 1;
    const hasSafeOpen = remainCnt > 0 || free === true;
    const showNormalOpen = !hasSafeOpen;
    const showSafeOpen = loading ? true : hasSafeOpen;
    return (React.createElement(Modal, { visible: visible, title: null, footer: null, closable: false, width: 560, centered: true, destroyOnClose: true, maskClosable: false, onCancel: onCancel, wrapClassName: styles.safeBrowsingModalWrap },
        React.createElement("div", { className: styles.header },
            React.createElement("div", { className: styles.title }, getIn18Text('第三方网站跳转提醒')),
            React.createElement("span", { className: styles.closeBtn, onClick: onCancel, role: "button", tabIndex: 0 }, "\u00D7")),
        React.createElement("div", { className: styles.body },
            React.createElement("p", { className: styles.paragraph }, getIn18Text('您即将离开网易邮箱，前往第三方网站 ({0})。 该网站风险未知，请慎重辨别，建议您开启安全浏览模式。', {
                0: targetUrl,
            })),
            React.createElement("div", { className: styles.card },
                React.createElement("div", { className: styles.cardHeader },
                    React.createElement(ShieldSvgIcon, { size: 20, className: styles.shield }),
                    React.createElement("span", { className: styles.cardTitle }, getIn18Text('安全浏览模式'))),
                React.createElement("p", { className: styles.cardDesc }, getIn18Text('通过安全浏览模式，可在隔离的环境中加载第三方链接，保障信息安全。')),
                React.createElement("div", { className: styles.cardFoot },
                    React.createElement("span", null,
                        getIn18Text('剩余次数: {0}次', { 0: Math.max(remainCnt, 0) }),
                        free && getIn18Text('BENCILIULBKCCS'))))),
        React.createElement("div", { className: styles.footer },
            React.createElement(Button, { onClick: onCancel }, getIn18Text('QUXIAO')),
            showNormalOpen && (React.createElement(Button, { onClick: onNormalOpen, className: styles.normalBtn }, getIn18Text('ZHIJIEDAK'))),
            showSafeOpen && (React.createElement(Button, { btnType: "primary", onClick: onSafeOpen }, getIn18Text('安全打开'))))));
};
export default SafeBrowsingModal;
